const Video = {
	isVisible: false,
};

export default {
	Video,
};
